import { render, staticRenderFns } from "./StatisticCardVertical.vue?vue&type=template&id=16354837&"
import script from "./StatisticCardVertical.vue?vue&type=script&lang=js&"
export * from "./StatisticCardVertical.vue?vue&type=script&lang=js&"
import style0 from "./StatisticCardVertical.vue?vue&type=style&index=0&id=16354837&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports